<template>
   <div class="wechatBinding">
    <NavBtn
      :on-click="back"
    />
    <div class="title">绑定微信</div>
    <div class="order">第一步</div>
    <section class="double-row step">
      <dl class="follow">
        <dt>1、打开微信，搜索公众号并关注</dt>
        <dd>
          <b @click="copyAccount">{{account}}</b>
        </dd>
      </dl>
      <dl class="code">
        <dt>2、点击<span>【 验证码 】</span>，复制验证码返回填写</dt>
      </dl>
    </section>
    <div class="order">第二步</div>
    <div class="double-row">
      <div>
        <span class="name">验证码：</span>
        <input
          type="tel"
          maxlength="6"
          placeholder="公众号中获取的验证码"
          v-model='captcha'>
      </div>
      <div>
        <span class="name">真实姓名：</span>
        <input type="text" placeholder="微信绑定的姓名，用于提现到账" v-model='realName'>
      </div>
    </div>
    <div class="btn-middle shadow" v-on:click='wechatSubmit'>绑定</div>
   </div>
</template>
<script>
import { mapActions } from 'vuex'
import $toast from '../common/Toast.js'
import { setPasteBoard } from '@/assistant/JSBridge'
import { URI_WECHAT_BINDING } from '@/store/modules/user/type'
export default {
  data () {
    return {
      realName: '',
      captcha: '',
      // account: 'lefupay' 原来的不用了，换成下边新的了
      // 丰阵小助手
      account: 'fengfupay'
    }
  },
  methods: {
    ...mapActions({
      bindWechat: URI_WECHAT_BINDING
    }),
    back () {
      this.$router.push('/user')
    },
    async wechatSubmit () {
      const reg = /[\u4e00-\u9fa5]+/g
      const captcha = this.captcha
      const realname = this.realName
      if (!captcha) {
        return $toast.show('请输入验证码', 1000)
      }
      if (!realname || !reg.test(realname)) {
        return $toast.show('请输入真实姓名', 1000)
      }
      const result = await this.bindWechat({
        realname,
        captcha
      })
      if (result && result.status === 200) {
        this.$router.replace('/user')
        $toast.show(result.data.payload.message, 1000)
      } else {
        $toast.show(result.data.payload.message, 1000)
      }
    },
    copyAccount () {
      setPasteBoard(this.account)
        .then((res) => {
          if (res['status'] === 'ok') {
            $toast.show('复制成功', 2000)
          } else {
            $toast.show(res['error'], 2000)
          }
        })
    }
  }
}
</script>
<style lang="scss" scoped>
@media only screen and (device-height: 812px) {
    .wechatBinding{
      padding-top: 24px !important;
    }
  }
  .wechatBinding{
      background-color: #3A4E92;
      height: 100%;
      padding-top: 34px;
      .back {
        position: absolute;
        top: 16px;
        left: 20px;
        width: 40px;
        height: 40px;
        background: #342F74;
        box-shadow: 0 3px 5px 0 #36308E;
        border-radius: 50%;
      }
      .title{
        text-align: center;
        font-size: 18px;
        color: #FFFFFF;
        margin-bottom: 30px;

        @include regular();
      }
      .order {
        width: 335px;
        font-size: 16px;
        color: #FFFFFF;
        height: 22px;
        line-height: 22px;
        margin: 0 auto 10px;

        @include semibold();
      }
      .step{
        padding-top: 15px;
        padding-bottom: 15px;
        dl{
          font-size: 13px;
          @include regular();
          dt{
            font-size: 13px;
            color: #3A3A3A;
            @include regular();
          }
          dd {
            font-size: 13px;
            color: #ddd;
            margin: 15px auto;
            b{
              font-size: 20px;
              color: #3A3A3A;
              margin-left: 10px;

              @include semibold();
            }
          }
        }
      }
      .double-row{
        height: auto;
        margin: 0 auto 40px;

        .name {
          font-size: 13px;
          color: #3A3A3A;

          @include regular();
        }

        input {
          font-size: 13px;
          color: #3A3A3A;
          width: 210px;
          border: none;
          outline: medium;
          background-color: transparent;

          @include regular();
        }
      }
      .btn-middle{
        margin: 0 auto;
      }
   }
</style>
